interface BlocoMapaProps {
  localNome: string;
  endereco: string | null;
  cidadeTexto: string;
  cep: string | null;
  enderecoCompleto: string;
}

function linkMapa(endereco: string): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(endereco)}`;
}

// Conteúdo de "Onde vai acontecer": endereço, mapa e link — usado dentro de um
// Accordion recolhido, nunca aberto de cara.
export default function BlocoMapa({
  localNome,
  endereco,
  cidadeTexto,
  cep,
  enderecoCompleto,
}: BlocoMapaProps) {
  return (
    <div>
      <div className="flex items-start gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[14px] bg-primary-50 text-primary-600">
          <i className="ri-map-pin-2-line text-[20px]" aria-hidden />
        </span>
        <div className="min-w-0">
          <p className="text-[15px] font-bold text-foreground-950">{localNome}</p>
          {endereco && <p className="mt-0.5 text-[14px] text-foreground-600">{endereco}</p>}
          <p className="mt-0.5 text-[14px] text-foreground-600">
            {cidadeTexto}
            {cep && ` · CEP ${cep}`}
          </p>
        </div>
      </div>

      {endereco && (
        <iframe
          title={`Mapa de ${localNome}`}
          src={`https://maps.google.com/maps?q=${encodeURIComponent(enderecoCompleto)}&output=embed`}
          className="mt-3 h-[220px] w-full rounded-[14px] border-0"
          loading="lazy"
          allowFullScreen
        />
      )}

      <a
        href={linkMapa(enderecoCompleto)}
        target="_blank"
        rel="noopener noreferrer nofollow"
        className="aperta mt-3 inline-flex cursor-pointer items-center gap-2 text-[14px] font-bold text-primary-600"
      >
        <span className="flex h-5 w-5 items-center justify-center">
          <i className="ri-external-link-line" aria-hidden />
        </span>
        Ver no mapa
      </a>
    </div>
  );
}